import useEnumPairsQuery from '../../../hooks/useEnumPairsQuery';
import SelectField, { SelectFieldProps } from '../SelectField';

type Props = {
  typename: string;
  transformer?: (enumPairs: ReturnType<typeof useEnumPairsQuery>) => ReturnType<typeof useEnumPairsQuery>;
} & Omit<SelectFieldProps, 'options'>;

const EnumPairSelectField = ({ typename, transformer = (enumPairs) => enumPairs, ...props }: Props) => {
  const enumPairs = useEnumPairsQuery(typename);
  return (
    <SelectField options={transformer(enumPairs).map(({ key, value }) => ({ id: key, text: value }))} {...props} />
  );
};

export default EnumPairSelectField;
export type { Props as EnumPairSelectFieldProps };
